export default __webpack_public_path__ + "static/media/personal_website.8f667ae9.png";